import { render, staticRenderFns } from "./TransferCenter.vue?vue&type=template&id=aaa54f46&scoped=true"
import script from "./TransferCenter.vue?vue&type=script&lang=js"
export * from "./TransferCenter.vue?vue&type=script&lang=js"
import style0 from "./TransferCenter.vue?vue&type=style&index=0&id=aaa54f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa54f46",
  null
  
)

export default component.exports